<template>
  <div class="w-full">
    <ReservationCodeForm v-if="isFormShown" :redemption="redemption" :should-focus-on-mount="isOpen" is-compact />
    <button v-else class="text-sm text-gold1 underline underline-offset-2" type="button" @click="onOpen">Apply Code</button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';

import type { ReservationCodeRedemption } from '@/wabunka-src/common/features/Reservation/composables/forms/useReservationCodeRedemption';
import ReservationCodeForm from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationCodeForm/ReservationCodeForm.vue';

interface Props {
  redemption: ReservationCodeRedemption;
}

const props = defineProps<Props>();

// Payment へ飛ばさずその場で開く。S4 に着いていないゲストもここからなら入れられる（D-031）
const isOpen = ref(false);
const isFormShown = computed(() => isOpen.value || props.redemption.appliedCodeName !== '');

const onOpen = () => {
  isOpen.value = true;
};

// 適用しても解除しても Apply Code のリンクへ畳み直す。開いたままだと解除した直後に空の入力欄が残る
watch(
  () => props.redemption.appliedCodeName,
  () => {
    isOpen.value = false;
  },
);
</script>
